module.exports = __webpack_public_path__ + "static/gallery16-e1c964190a4dafa9ec509eaf10137595.jpg";